import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import { SmbMain } from "../components/styles/Smb.styled";
import { useEffect, useRef } from "react";
import { showCenteredToast } from "../components/CenteredToast";

const SmbProcess = () => {
  const navigate = useNavigate();
  const iframeRef = useRef<any>(null);
  const expireDate = sessionStorage.getItem("smbExpireDate");
  const term = sessionStorage.getItem("smbTerm");

  const storedTrackId = sessionStorage.getItem("smbTrackId");
  const savedAddress = localStorage.getItem('saved_address');
  console.log(savedAddress,"saved_address")

  useEffect(() => {
    if (!expireDate || !term) {
      navigate("/smb/");
      return;
    }
  }, [expireDate, term, navigate]);

  useEffect(() => {
    function handleMessage(event:any) {
      const { type, payload } = event.data || {};

      if (event.data?.type === "resize" && iframeRef.current) {
        iframeRef.current.style.height = event.data.height + "px";
      }

      if (type === "SHOW_TOAST") {
        showCenteredToast(payload.message, {
          onConfirm: () => {},
        });
        // toast(payload.message, payload.options);
      }
      if (type === "SMB_NAVIGATE") {
        sessionStorage.removeItem("smbTrackId");
        navigate("/");
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const iframeUrl = (() => {
    const url = new URL("https://embed.smb.eiqshopping.com/");
    url.searchParams.set("expireDate", String(expireDate));
    url.searchParams.set("term", String(term));
    url.searchParams.set("trackId", String(storedTrackId));
    url.searchParams.set("savedAddress", savedAddress || "");
    url.searchParams.set("utm-content", "shopbusinesspower");
    
    const externalTrackId = sessionStorage.getItem("externalTrackId");
    const trafficSource = sessionStorage.getItem("trafficSource");
    if (externalTrackId) url.searchParams.set("externalTrackId", externalTrackId);
    if (trafficSource) url.searchParams.set("trafficSource", trafficSource);
    
    return url.toString();
  })();

  return (
    <>
      <SmbMain>
        <Header />
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          title="smb-process"
          ref={iframeRef}
          style={{ overflow: "hidden" }}
        />
      </SmbMain>
    </>
  );
};

export default SmbProcess;
